import type { Applicant } from "@/types/form";

/** Latest main-applicant SSN for co-applicant duplicate validation in economy form resolver. */
export const mainApplicantNationalIdRef: { current: string | undefined } = {
	current: undefined,
};

/** Latest main-applicant contact values for co-applicant duplicate validation. */
export const mainApplicantContactRef: {
	current: Pick<
		Applicant,
		"nationalId" | "mobileCountry" | "mobileNumber" | "emailAddress"
	> | undefined;
} = { current: undefined };
